import { ClearableTextInput, CollectionView, DestroyingContentSwitcher, Div, Filters, Ref, RefString, Select, Snack } from "@tblabs/truffle";
import { Router } from "../../../Services/Router";
import { OrdersManager } from "../../../Services/Storage/OrdersManager";
import { OrdersFolders } from "../../../Models/OrdersFolders";
import { TableView } from "./Views/Table/TableView";
import { TodoView } from "./Views/ToDo/TodoView";
import { CalendarView } from "./Views/Calendar/CalendarView";
import { ProfitView, ProfitViewV2 } from "./Views/Calendar/ProfitView";
import { TasksView } from "./Views/Tasks/TasksView";
import { AgentsProvider } from "../../../Services/Agents/AgentsProvider";
import { OriginsView, OriginsViewV2 } from "./OriginsView";
import { Page } from "../../Page";


export class OrdersViewPage extends Page
{
    constructor(private _manager: OrdersManager, private _router: Router, private _agents: AgentsProvider)
    {
        super("Zamówienia");

        this.Content(async (body) =>
        {
            const ordersSet = new Ref<OrdersFolders>(OrdersFolders.Open).Storable("orders-set");

            await this._manager.LoadAll(ordersSet.value);

            const view = new RefString("steps").Storable("orders-view");

            const filter = new RefString().Storable("orders-filter");
            filter.OnChange(() => view.value = "table");

            const ordersView = new CollectionView(this._manager.Orders)
                .Filter(filter, order => Filters.TextContains(filter, [order.SearchBy]))
                .Refresh()

            const content = new DestroyingContentSwitcher(view)
                .AddContent("table", () => new TableView(this._router, this._manager, ordersView))
                .AddContent("calendar", () => new CalendarView(this._router, ordersView))
                .AddContent("todo", () => new TodoView(this._router, this._manager, this._agents, ordersView))
                .AddContent("profit", () => new ProfitView(ordersView))
                .AddContent("profit-2", () => new ProfitViewV2(_manager))
                .AddContent("tasks", () => new TasksView(this._manager.Orders))
                .AddContent("origins", () => new OriginsView(ordersView))
                .AddContent("origins-2", () => new OriginsViewV2(_manager))

            ordersSet.OnChange(async (set) =>
            {
                const info = new Snack("Ładowanie zamówień...");
                await this._manager.LoadAll(set);
                info.Close();
                content.Refresh();
            })

            body.TextAlignLeft().Append(
                new Select(ordersSet, { "🟢 Aktualne": OrdersFolders.Open, "🟤 Zamknięte": OrdersFolders.Closed }).WidthAuto().Margin(8),
                new ClearableTextInput(filter, "Szukaj...").DisplayInlineBlock().WidthAuto(),
                new Select(view, {
                    "🍔 Tabela": "table",
                    "🍂 Zadania": "todo",
                    "🚀 Akcje": "tasks",
                    "📅 Kalendarz": "calendar",
                    "💰 Profit": "profit",
                    "💰 ProfitV2": "profit-2",
                    "🧭 Źródła": "origins",
                    "🧭 ŹródłaV2": "origins-2",
                }).WidthAuto().Margin(8).FloatRight().PaddingRight(32),
                new Div().ClearBoth(),
                content,
            );
        });
    }
}
